import { PartyType } from '@parties/src/types';
import { useQuery } from 'react-query';
import { wgApi } from '../../../../app/src/features/api/wgApi';
import {
  GetSupportedYellowhiveflowCoveragesResponse,
  GetSupportedYellowhiveflowCoveragesQueryParams,
} from 'wg-api-sdk';

const getYellowhiveFlowsCoverages = async (
  partyType: PartyType,
  insuranceCodes: string[] = [],
) => {
  const query: GetSupportedYellowhiveflowCoveragesQueryParams = {
    party_type: partyType,
    insurance_codes: insuranceCodes,
  };
  const { data, isError } =
    await wgApi.get<GetSupportedYellowhiveflowCoveragesResponse>(
      `/v1/api/yellowhiveflows/supported-coverages`,
      {
        query,
      },
    );
  if (isError) throw new Error();
  return data;
};

const getUseYellowhiveFlowsCoveragesQkey = (
  partyType: PartyType,
  insuranceCodes?: string[],
) => ['flow-config', 'yellowhive', 'coverages', partyType, insuranceCodes];

export const useYellowhiveFlowsCoverages = (
  partyType: PartyType,
  insuranceCodes?: string[],
) => {
  return useQuery(
    getUseYellowhiveFlowsCoveragesQkey(partyType, insuranceCodes),
    () => getYellowhiveFlowsCoverages(partyType, insuranceCodes),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  );
};
